import { Controller } from "@hotwired/stimulus"

// The tap on the door's egg: the egg brightens and rocks, and the server
// remembers. On the door it warms where it stands and the name form under it
// never moves; on a letter reader's egg-first page (`then`) the door follows.
// A browser without this script posts the form and is sent to the door.
const WARMING_MS = 650

export default class extends Controller {
  static targets = [ "note" ]
  static values = { then: String }

  warm(event) {
    event.preventDefault()
    if (this.warming || this.element.classList.contains("is-warm")) return

    this.warming = true
    const still = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (!still) this.element.classList.add("is-warming")

    const sent = fetch(this.element.action, {
      method: "POST",
      body: new FormData(this.element),
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    }).catch(() => {})
    const shown = new Promise((resolve) => setTimeout(resolve, still ? 0 : WARMING_MS))

    Promise.all([ sent, shown ]).then(() => {
      if (this.hasThenValue && this.thenValue) {
        window.location.assign(this.thenValue)
        return
      }
      this.element.classList.remove("is-warming")
      this.element.classList.add("is-warm")
      this.element.querySelector("button")?.setAttribute("disabled", "")
      if (this.hasNoteTarget) {
        this.noteTarget.textContent = "Your egg is warm now. It hatches the morning after you take it."
      }
    })
  }
}
